<template>
  <li class="dialog-tree-row" v-bind:class="{'bg-highlight':hidden}">
    <div v-if="!loading">
      <div
        v-if="!editing && $store.claims.phrases > 2"
        class="edit-icons"
      >
      
        <div class="icon-container">
            <span v-if="phrase.attachments && phrase.attachments.filter(x => x.type == 'audio' && x.language == $store.preferredLanguage).length > 0">
                <i v-if="!playing" @click="playAudio()" class="material-icons blue-text" style="margin-right:5px">play_circle_filled</i>
                <i v-if="playing" @click="stopAudio()" class="material-icons blue-text" style="margin-right:5px">stop</i>
                <i @click="showWarning()" class="material-icons red-text text-darken-1" style="margin-right:5px;">delete</i>
                <img v-if="dynamicVideoLanguageVideo" class="material-icons" style="height:20px;width:40px" src="../assets/video_icon.png" v-on:click="videoPlay()" />
              </span>
              <span v-if="dialog.attachments && dialog.attachments.filter(x => x.ContentType == 'video/mp4' && x.language == $store.preferredLanguage).length > 0">
                <img class="material-icons" style="height:20px;width:40px" src="../assets/video_icon.png" v-on:click="videoPlay()" />

              </span>
              <div v-if="showVideoModal" class="overlay">
                <div class="card" style="display: inline-block">
                  <div class="modal-content">
                    <video
                          v-if="this.dynamicVideoLanguageVideo"
                          :src="this.dynamicVideoLanguageVideo"
                          style="height:360px;width:400px;margin:10px"
                          controls
                    ></video>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" @click="uploadVimeoVideo">Upload Video</button>
                    <button class="btn-flat" style="float: right" @click="closeVideoModal()">close</button>
                  </div>
                </div>
              </div>

              <i
            v-if="$store.checkVisibility && isHidden()"
            class="material-icons grey-text text-darken-1"
        >visibility_off</i>
          <i
            v-if="!isStart"
            class="material-icons grey-text text-darken-1"
            @click="edit()"
          >edit</i>
        </div>
        
      </div>

      <div
        :id="'d' + dialog.id"
        @click="toggle"
        v-if="!editing"
        class="text-preview"
        v-bind:class="{'grey-text text-darken-1': isStart}"
      >
        <span v-if="!isStart && $store.inspectionViewMT" class="number-badge">{{itemNumber}}</span>

        <i
          class="material-icons"
          v-bind:class="{'outline': open && !isStart, 'helen-green-text': !isStart}"
          :id="dialog.id"
        >{{icon}}</i>
        <div class="preview-div">
          {{ primaryTranslation }}
          <div
            v-if="!isStart"
            dir="auto"
            class="secondary-language"
            :id="'secondary-translation-' + dialog.id"
          >{{ secondaryTranslation }}</div>
        </div>
      </div>
      <div v-if="editing" class="editingBox">
        <div class="toolbar">
          <i @click="edit()" class="material-icons prefix grey-text text-darken-1">undo</i>
          <i @click="save()" class="material-icons prefix grey-text text-darken-1">save</i>
        </div>
        <div class="input-field">
          <textarea
            type="text"
            v-model="editingPhraseText"
            :style="'height:'+setRows(dialog.id)+'rem'"
          ></textarea>
        </div>
        <div
          v-if="!isStart"
          dir="auto"
          class="secondary-language"
          :id="'secondary-translation-edit-' + dialog.id"
        >{{ secondaryTranslation }}</div>
      </div>
      <ul v-show="open" class="browser-default dialog-tree-list" v-bind:class="{start: isStart}">
        <ReviewTreeItem
          v-for="(id, index) in dialog.next"
          :key="index"
          :itemNumber="isStart ? (index+1).toString() : itemNumber+'.'+(index+1)"
          :parentOpen="open"
          :dialog="nextDialogs[id]"
          v-if="nextDialogs[id]"
        />
      </ul>
      <ul
        v-show="open && empty"
        class="browser-default dialog-tree-list"
        v-bind:class="{start: isStart}"
      >
        <li class="grey-text text-darken-1 text-preview">Empty</li>
      </ul>
    </div>
    <Spinner v-if="loading" :size="'tiny'" />
    <Modal
        v-if="showDeleteModal"
        content="Are you sure you want to delete the audio."
        :actions="deleteModalActions"
        header="Warning"
      />
  </li>
</template>

<script>
import Spinner from "./Spinner";
import Modal from "./Modal"
export default {
  name: "ReviewTreeItem",
  props: {
    dialog: Object,
    parentOpen: Boolean,
    itemNumber: String,
  },
  components: {
    Spinner,
    Modal
  },
  data() {
    return {
      hidden:false,
      showVideoModal:false,
      open: true,
      phrase: {},
      nextDialogs: {},
      editing: false,
      editingPhraseText: "",
      loadingDialogs: true,
      loadingPhrase: true,
      initalized: false,
      playing:false,
      showDeleteModal:false,
      attachmentToBeRemovedLanguage:"",
      uploadVideo:null,
      deleteModalActions: {
        Delete: () => {
          this.removeAttachment();
          this.showDeleteModal = false;
        },
        Cancel: () => {
          this.showDeleteModal = false;
        },
      },
      dynamicVideoLanguage: null,
      dynamicVideoLanguageVideo: null,
    };
  },
  watch: {
    "$store.lastPhraseUpdated": function (p) {
      var ID = p.id;
      if (ID == this.phrase.id) {
        this.phrase = Object.assign({}, this.$store.lastPhraseUpdated);
      }
    },
    parentOpen: function (isOpen) {
      if (!isOpen) {
        this.open = false;
      } else if (!this.initialized) {
        if (this.dialog.next)
          this.getNext()
            .then(() => (this.loadingDialogs = false))
            .catch(() => (this.loadingDialogs = false));
        else {
          this.toggle();
          console.log("no next");
        }
        this.initialized = true;
      }
    },
    "dialog.phrase": function (id) {
      this.getPhraseByID(id);
    },
    "dialog.next": function (list) {
      this.nextDialogs = Object.keys(this.nextDialogs)
        .filter((d) => {
          return (
            this.dialog.next.indexOf(this.nextDialogs[d].id) > -1 ||
            this.nextDialogs[d].new
          );
        })
        .reduce((obj, key) => {
          obj[key] = this.nextDialogs[key];
          return obj;
        }, {});
      var newDialogs = [];
      if (this.dialog.next)
        this.dialog.next.forEach((id) => {
          if (!this.nextDialogs[id]) {
            newDialogs.push(id);
          }
        });
      newDialogs.forEach((element) => {
        this.getDialogByID(element);
      });
    },
    "$store.dynamicVideoLanguageLoaded": function (loaded) {
      if (!loaded) return;
      this.dynamicVideoLanguage = this.$store.dynamicVideoLanguageItems[this.dialog.old_id];
      this.setDynamicVideoLanguageVideoByLanguage();
    }
  },
  methods: {
    playAudio(){
      console.log(this.dialog)
    if(!this.phrase.attachments) return;
    console.log(this.phrase.attachments)
    let attachment = this.phrase.attachments.filter(x => x.type == "audio" && x.language == this.$store.preferredLanguage)[0].id;
    if(this.$store.reviewTreePlayer){
          this.stopAudio();
    }
    
      this.$store.reviewTreeItem = this;
      this.$store.reviewTreePlayer = new Audio(
        window.baseURL +
          "/phrases/" +
          this.phrase.id +
          "/attachments/" +
          attachment +
          "/?token=" +
          this.$store.token
      );
      this.$store.reviewTreePlayer.addEventListener("ended", () => {
        this.$store.reviewTreePlayer = null;
        this.playing = false;
      });
      this.playing = true;
      this.$store.reviewTreePlayer.play();
    },
    stopAudio(){
        if(this.$store.reviewTreePlayer){
          this.$store.reviewTreePlayer.pause();
          this.$store.reviewTreePlayer = null;
        }
        if(this.$store.reviewTreeItem){
        this.$store.reviewTreeItem.playing = false;
        }
    },
    showWarning(){
        this.stopAudio();
        this.showDeleteModal = true;
        this.attachmentToBeRemovedLanguage = this.$store.preferredLanguage;
    },
    videoPlay(){
      this.showVideoModal=true
    },
    closeVideoModal(){
      this.showVideoModal=false
    },
    async removeAttachment(){
      var p = [];
      M.toast({"html":"Deleting Audio...", "classes":"blue", "displayLength":600000});
      var indices = [];
      this.phrase.attachments.forEach((a,i) => {
        if(a.type == "audio" && a.language == this.attachmentToBeRemovedLanguage){
          p.push(this.$http.delete("/phrases/" + this.phrase.id + "/attachments/" + a.id));
          indices.push(i);
        }
      })
      await Promise.all(p);
      indices = indices.reverse();
      indices.forEach(i => {
        this.phrase.attachments.splice(i,1);
      })
      this.$store.lastPhraseUpdated = this.phrase;
      this.attachmentToBeRemovedLanguage = "";
      M.Toast.dismissAll();
      M.toast({"html":"Audio deleted.", "classes":"green"});
    },
    isHidden() {
      var rootName = this.$store.instanceMT;
      if(!this.$parent || !this.$parent.dialog){
          return false;
      }
      var parentId = this.$parent.dialog.old_id;
      if (this.$parent.hidden) {
        this.hidden = true;
        return true;
      }
      if(this.dialog.tags && this.dialog.tags.indexOf("start_" + rootName + ":" + parentId + ":" + "hidden") >= 0){
        this.hidden = true;
        return true;
      }
      this.hidden = false;
      return false;
    },
    setRows(id) {
      var target = document.getElementById("secondary-translation-" + id)
        ? document.getElementById("secondary-translation-" + id)
        : document.getElementById("secondary-translation-edit-" + id);
      if (!target) return 8;
      var style = window.getComputedStyle(target, null);
      var height = parseInt(style.getPropertyValue("height"));
      var font_size = parseInt(style.getPropertyValue("font-size"));
      var line_height = parseInt(style.getPropertyValue("line-height"));
      var box_sizing = style.getPropertyValue("box-sizing");

      if (isNaN(line_height)) line_height = font_size * 1.2;

      if (box_sizing == "border-box") {
        var padding_top = parseInt(style.getPropertyValue("padding-top"));
        var padding_bottom = parseInt(style.getPropertyValue("padding-bottom"));
        var border_top = parseInt(style.getPropertyValue("border-top-width"));
        var border_bottom = parseInt(
          style.getPropertyValue("border-bottom-width")
        );
        height =
          height - padding_top - padding_bottom - border_top - border_bottom;
      }
      var lines = Math.ceil(height / line_height);
      lines = 2 * lines;
      return lines < 5 ? 4 * lines : 2 * lines;
    },
    /**
     * Toggle folder state
     */
    toggle() {
      this.open = !this.open || this.isStart;
    },
    /**
     * Fetch dialog based on ID
     * @param {string} id ID of dialog to fetch
     */
    getDialogByID(id) {
      return new Promise((resolve, reject) => {
        var dialog = Object.assign({}, this.$store.dialogsMT[id]);
        var dID = this.$store.dialogCounter++;
        dialog.id = dID;
        if (!dialog.next) dialog.next = [];
        dialog.next = dialog.order || [];
        this.$store.loadCount += dialog.next.length;
        this.$set(this.nextDialogs, id, dialog);
        resolve();
      });
    },
    /**
     * Fetch phrase based on ID
     * @param {number} id ID of pharse to fetch
     */
    getPhraseByID(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve();
          return;
        }
        this.$store.loadCount -= 1;
        this.phrase = this.$store.phrasesMT[id];
        this.$store.checkTranslationPhrases[this.dialog.id] = this.phrase;
        resolve();
      });
    },
    /**
     * Toggle editing state
     */
    edit() {
      this.editing = !this.editing;
      if (this.editing) {
        this.editingPhraseText = this.primaryEditingTranslation;
      }
    },
    /**
     * Call for saving changes to current dialog
     */
    save() {
      if (this.editingPhraseText.length < 1) {
        this.toast("You can't add an empty phrase");
        return;
      }
      var translationExist =
        this.phrase.translations.filter(
          (t) => t.language == this.$store.preferredLanguage
        ).length > 0;
      if (translationExist) {
        this.phrase.translations.forEach((t) => {
          if (t.language == this.$store.preferredLanguage) {
            t.text = this.editingPhraseText;
          }
        });
      } else {
        var translation = {
          text: this.editingPhraseText,
          language: this.$store.preferredLanguage,
        };
        this.phrase.translations.push(translation);
      }
      this.$http.put("phrases/" + this.phrase.id, this.phrase).then((r) => {
        this.$store.lastPhraseUpdated = this.phrase;
        this.toast("Phrase saved!");
        this.editing = false;
      });
    },
    /**
     * Retireves the next dialogs
     */
    getNext() {
      return new Promise((resolve, reject) => {
        var a = this.dialog.next.map((id) => {
          return this.getDialogByID(id);
        });
        Promise.all(a).then(() => resolve());
      });
    },
    toast(text) {
      M.toast({
        html: text,
      });
    },
    setDynamicVideoLanguageVideoByLanguage() {
      if (this.$store.loggedInUser.username!='admin') return;
      console.log("rvt set:",this.dynamicVideoLanguage);
      if (!this.dynamicVideoLanguage) return;
      const l = this.$store.preferredLanguage;
      console.log("rvt set",l);
      this.$store.getDialogById(this.dialog.old_id).then(response => {
        console.log("rvt set d:",response);
        if (!response.attachments) return;
        const v = response.attachments.find(a => a.filename.includes("_dvl_"+l));
        console.log("rvt set:",v);
        var instVs = this.$store.instructionAttachments[response.id];
        this.getVideoAttachment(v.id, response.id).then(_r => {
          instVs = this.$store.instructionAttachments[response.id];
          const instV = instVs.find(e => e.id == v.id);
          this.dynamicVideoLanguageVideo = instV.data;
        });
      });
    },
    getVideoAttachment(id, instructionId) {
      var vm = this;
      return new Promise((resolve, reject) => {
        this.$http
          .get("dialogs/" + instructionId + "/attachments/" + id, {
            responseType: "arraybuffer",
          })
          .then(
            (response) => {
              const arrayBuffer = response.data; // Assuming `response.data` contains the ArrayBuffer
               this.uploadVideo = new File([arrayBuffer], 'video.mp4', { type: 'video/mp4' });
              let video = btoa(
                new Uint8Array(response.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
              var instVid = `data:${response.headers[
                "content-type"
              ].toLowerCase()};base64,${video}`;
              var videoArray = vm.$store.instructionVideos[instructionId]
                ? vm.$store.instructionVideos[instructionId]
                : [];
              var videoIdArray = vm.$store.instructionVideosId[instructionId]
                ? vm.$store.instructionVideosId[instructionId]
                : [];

              var videoPresent = true;
              if (videoIdArray.length == 0) {
                videoPresent = false;
              } else {
                if (
                  vm.$store.instructionVideosId[instructionId].indexOf(id) == -1
                ) {
                  videoPresent = false;
                }
              }

              var obj = {
                type: "video",
                data: instVid,
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              if (!videoPresent) {
                videoArray.splice(videoArray.length, 0, instVid);
                videoIdArray.splice(videoIdArray.length, 0, id);
                vm.$set(vm.$store.instructionVideos, instructionId, videoArray);
                vm.$set(
                  vm.$store.instructionVideosId,
                  instructionId,
                  videoIdArray
                );
              }
              resolve();
            },
            (r) => {
              var obj = {
                type: "video",
                data: ".mp4",
                id: id,
              };

              vm.$store.instructionAttachments = vm.$store
                .instructionAttachments
                ? vm.$store.instructionAttachments
                : {};
              var instAttachments = vm.$store.instructionAttachments[
                instructionId
              ]
                ? vm.$store.instructionAttachments[instructionId]
                : [];
              instAttachments.push(obj);
              vm.$set(
                vm.$store.instructionAttachments,
                instructionId,
                instAttachments
              );

              resolve();
            }
          );
      });

     },
    /**
     * Upload video code 
     * 
     */
    async uploadVimeoVideo() {
      const tokenHeader = window.axios.defaults.headers.common["token"];
      delete window.axios.defaults.headers.common["token"];
      var videoName = this.dialog.old_id+"_dvl_"+this.$store.preferredLanguage
      const data = {
                      upload: {
                        approach: 'tus',
                        size: this.uploadVideo.size
                      },
                      "name": videoName,
                    };
      axios
        .post('https://api.vimeo.com/me/videos', data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: this.$vimeobearertoken,
            Accept: 'application/vnd.vimeo.video+json;version=3.4',
          },
          params: {
            fields: 'name,upload.upload_link,uri,upload.upproach',
          },
        })
        .then((response) => {
          const videoData = response.data;
          const uploadLink = videoData.upload.upload_link;
          const videoUri = videoData.uri;
          console.log('Video uploaded successfully:', videoData);
          console.log('uri:', videoData);
          console.log('Video URI:', videoUri);

          axios
            .patch(uploadLink, this.uploadVideo,{
              headers: {
                'Tus-Resumable': '1.0.0',
                'Upload-Offset': '0', 
                'Content-Type': 'application/offset+octet-stream',
              },
            })
            .then((response) => {
              const uploadOffset = response.headers['upload-offset'];
              window.axios.defaults.headers.common["token"] = tokenHeader;
              console.log('Video uploaded successfully');
              M.toast({"html":"Video uploaded to vimeo", "classes":"green"});
              const TWO_MINUTES = 120000;
              setTimeout(() => this.getVimeoDirectLink(videoUri), TWO_MINUTES);
            })
            .catch((error) => {
              console.error('Error uploading video:', error);
              window.axios.defaults.headers.common["token"] = tokenHeader;
            });

        })
        .catch((error) => {
          console.error('Error uploading video:', error);
          window.axios.defaults.headers.common["token"] = tokenHeader;
        });
    },
    async getVimeoDirectLink(videoUri) {
      const tokenHeader = window.axios.defaults.headers.common["token"];
      delete window.axios.defaults.headers.common["token"];
      axios
        .get('https://api.vimeo.com'+videoUri+'?fields=files',{
          headers: {
            'Content-Type': 'application/json',
            Authorization: this.$vimeobearertoken,
            Accept: 'application/vnd.vimeo.video+json;version=3.4',
          },
        })
        .then((response) => {
          console.log(response);
          window.axios.defaults.headers.common["token"] = tokenHeader;
          const link = response.data.files.find(e => e.rendition == "360p").link;
          this.addVideoLink(link);
          M.toast({"html":"Video attached to dialog", "classes":"green"});
        })
        .catch((error) => {
          console.error('Error getting video direct files:', error);
          window.axios.defaults.headers.common["token"] = tokenHeader;
        });
    },
    addVideoLink(link){
     var data = {
          text: link,
          language: this.$store.preferredLanguage
        };
     var instructionId = this.$store.currentDialogId;
     this.$http.post("/dialogs/"+this.dialog.old_id+"/attachmentsText",data).then(function(r){
          var obj = {
            type:"link",
            data:link,
            id:r.data.id
          };
     }).catch(function(){
      console.log("error while uploading video :");
    });
    },
  },
  mounted() {
    this.$set(this.$store.dialogsItemNumber, this.dialog.id, this.itemNumber);
  },
  /**
   * Intitialize the component
   */
  created() {
    if (this.$store.dynamicVideoLanguageLoaded) {
      console.log(this.$store.dynamicVideoLanguageItems);
      console.log(this.dialog);
      this.dynamicVideoLanguage = this.$store.dynamicVideoLanguageItems[this.dialog.old_id];
      this.setDynamicVideoLanguageVideoByLanguage();
    }
    if (this.isStart) this.open = true;
    if (this.dialog.new) this.edit();
    this.getPhraseByID(this.dialog.phrase)
      .then(() => (this.loadingPhrase = false))
      .catch(() => (this.loadingPhrase = false));
    if (this.parentOpen) {
      if (this.dialog.next && this.dialog.next.length)
        this.getNext()
          .then(() => {
            this.loadingDialogs = false;
            this.initialized = true;
          })
          .catch(() => {
            this.loadingDialogs = false;
            this.toast("Could not fetch the next set of dialogs");
          });
      else {
        this.loadingDialogs = false;
        this.initialized = true;
        this.toggle();
      }
    }
  },
  computed: {
    secondaryTranslation() {
      if (this.isStart) return "";

      if (this.$store.secondaryLanguageMT === "")
        return "No secondary language is selected";

      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.secondaryLanguageMT
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for the secondary language";
    },
    /**
     * Get translation based on current preferred language
     */
    primaryTranslation() {
      if (this.isStart) return this.$store.instanceMT;
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      if (foundTranslation) return foundTranslation.text;
      return foundTranslation
        ? foundTranslation.text
        : "Phrase has no translation for this language";
    },

    /**
     * Get translation based on current preferred language (if none found => '')
     */
    primaryEditingTranslation() {
      if (this.phrase.translations)
        var foundTranslation = this.phrase.translations.filter(
          (t) => t.language === this.$store.preferredLanguage
        )[0];
      return foundTranslation ? foundTranslation.text : "";
    },
    /**
     * Get icon based on dialog's type
     */
    icon() {
      const types = {
        answer: "chat",
        instruction: "feedback",
        question: "help",
        category: "folder",
        start: "view_list",
        default: "error",
        instruction_paragraph: "linear_scale"
      };
      return (
        types[this.dialog.type] || types[this.isStart ? "start" : "default"]
      );
    },
    /**
     * Returns last editor of dialog
     */
    editor() {
      const modifier = this.$store.users.filter(
        (u) => u.id === this.dialog.editor
      )[0];
      return modifier ? modifier.username : "";
    },
    creationInfo() {
      const creator = this.$store.users.filter(
        (u) => u.id === this.dialog.creator
      )[0];
      return creator && this.dialog.created
        ? "Created by " +
            creator.username +
            " ( " +
            this.dialog.created.split("T")[0] +
            " " +
            this.dialog.created.split("T")[1].slice(0, 5) +
            " )"
        : "";
    },
    /**
     * Get empty state of nextDialogs
     */
    empty() {
      for (var key in this.nextDialogs) {
        if (this.nextDialogs.hasOwnProperty(key)) return false;
      }
      return true;
    },
    /**
     * Returns if dialog is start-dialog
     */
    isStart() {
      return this.dialog.tags && this.dialog.tags.indexOf("start") > -1;
    },
    /**
     * Returns if the dialog is loading
     */
    loading() {
      return this.loadingPhrase || this.loadingDialogs;
    }
  },
};
</script>

<style scoped>
.start {
  padding-left: 0em;
}

ul.start > li > div > ul li {
  border-top: 1px solid #ccc;
  margin-bottom: -1px;
}
ul.start > li > div > ul li:hover {
  border-left: 2px solid dimgray;
  padding-left: 2px;
}
ul.start > li {
  padding: 5px;
  padding-right: 0px;
}
ul.start > li:nth-child(2n + 1) {
  background: #efefef;
  border-left: 2px solid #b7b7b7;
}
ul.start > li:nth-child(2n) {
  border-left: 2px solid #fff;
}

.center {
  position: relative;
  margin-left: -50%;
  left: -50%;
}

.answer-types > label {
  margin-right: 1em;
}

.answer-types > p {
  color: darkgray;
}

.icon-spacer {
  width: 24px;
  height: 24px;
  margin-left: 15px;
}

.dialog-tree-list {
  list-style-type: none;
}

.text-preview {
  white-space: nowrap;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-right: 72px;
}

.dialog-tree-row {
  cursor: pointer;
  padding-left: 0;
}

.material-icons {
  display: inline-flex;
  vertical-align: top;
  user-select: none;
}

.editingBox {
  border: 1px solid lightgray;
  padding: 0em 1em 0em 1em;
  margin-right: 1px;
  background: #fff;
}

.edit-icons {
  position: relative;
}
.icon-container {
  position: absolute;
  right: 0;
  top: 0.4em;
}
.toolbar {
  text-align: right;
  margin: 0em -1em 0em -1em;
  padding: 0.5em 1em 0.5em 1em;
  border-bottom: 1px solid lightgray;
}

.toolbar > i {
  margin-left: 0.5em;
}

.toolbar > i:hover {
  color: #6eb2bd !important;
}

.toolbar > .left {
  margin-left: 0;
}

.toolbar > .left:hover {
  color: #e57373 !important;
}
.number-badge {
  font-weight: 300;
  color: #fff;
  background-color: grey;
  border-radius: 2px;
  padding: 0 6px;
  vertical-align: top;
}
.changevid{
  margin-left: 100px;
}
.changeimg{
  margin-left: 100px;
}
.upload-image-body{
  width: 280px;
}

#video-player{
	width: 250px;
	height: 150px;
  margin-top: 20px;
}

.overlay{
width:100vw;
height:100vh;
position:fixed;
top:0;
left:0;
background:rgba(0,0,0,.4);
z-index:999;
cursor:initial;
display:flex;
justify-content: center; 
align-items: center;
}
.upload-image-wrapper{
box-shadow:2px 2px 3px #888;
left:calc(50% - 150px);
top:calc(50% - 250px);
margin:-8px;
width:300px;
position:fixed;
padding:10px;
text-align:center;
align-content: center;
color:dimgray;
background:#f7f7f7;
z-index:10;
animation: grow .25s;
}

@keyframes grow {
  from {
    transform: scale(0.75) ;
  }
  to {
    transform:  scale(1) ;
  }
}

.close{
width:20px;
height:20px;
position:absolute;
right:5px;
top:0px;
}
.close button{
background:none;
border:0px;
font-weight:600;
}
 button:hover{
cursor:pointer;
color: red;
}
.upload-image-head,.update-image-head{
padding:10px;
font-size:22px;
}

.upload-image-buttons button, .upload-video-buttons button{
 border:0px;
 color:white;
 padding:10px 0px;
 width:80%;
 background:#0098ff;
 left:10%;
 position:relative;
}

.upload-video-buttons button{
  margin-top: 20px;
}

.delete-change-image-buttons, .delete-change-video-buttons{
display:inline;
}
.delete-change-image-buttons button, .delete-change-video-buttons button{
border:0px;
color:white;
padding:10px 0px;
background:#0098ff;
}

.delete-change-image-buttons button{
  width:40%;
}

.delete-change-video-buttons button{
  width:80%;
}

#video-link-inputbox{
  width: 80%;
  left: 10%;
  margin-top: 30px;
}

#video-link-input{
  width: 80%;
  border-bottom-color: #0098ff;
}

#video-link-inputbox label{
  color: #0098ff;
}

.video-link-add-btn{
  padding-left:5px; 
  padding-right:5px; 
  float:right; 
  margin-top:10px;
  background-color: #0098ff;
}

.video-link-add-btn:hover{
  background-color: #0098ff;
}
.preview-div {
  display: inline-block;
  white-space: normal;
  padding-right: 72px;
}
.instruction-image-wrapper {
  max-height: 212px;
  overflow-x: auto;
  background: white;
  display: flex;
  overflow-y: hidden;
}
.bg-highlight {
  background: #fff59d !important;
}
.highlight {
  background: #fffbce !important;
}
.secondary-language {
  font-size: 12px;
  color: #888;
}
</style>